export class Transporte {
    codigo: number;
    nombre: string;
    foto: any;
    link: string;
}